document.addEventListener('swiper:loaded', function (e) {   
  const Swiper = e.detail.Swiper;
// // Home banner slider
// $('.home_slider').slick({
//         dots: false,
//         fade:true,
//         infinite: true,
//         arrows:false, 
//         autoplay: false,
//          adaptiveHeight: true,
//         speed: 700,
//         slidesToShow: 1,
//         slidesToScroll: 1
  // });
  
  new Swiper('.home_banner', {
    autoHeight: false
  });
  
  $('a[href="#"]').attr('href', 'javascript:void(0)');
});


var elem = document.getElementById("myvideo");
function openFullscreen() {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) { 
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { 
    elem.msRequestFullscreen();
  }
}

$(document).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
    var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
    var event = state ? 'FullscreenOn' : 'FullscreenOff';

   
   if(event === 'FullscreenOff') {
   
     $('#myvideo').get(0).pause();
     $('#myvideo').get(0).currentTime = 0;
   } else {
  $('#myvideo').get(0).play(); 
   }
});

$(document).on("click","#mo_myvideo",function(e){
  $(this).addClass('hide'); 
 const videoElement = document.getElementById('myvideo_mo');
        if (videoElement.playing) {
            // video is already playing so do nothing
        }
        else {            
            videoElement.play();
        }
});



